import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { accounts, inProgress } = useMsal();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (inProgress !== InteractionStatus.None) {
          return <></>;
        }
        return accounts && accounts.length > 0 ? (
          <Component {...props} />
        ) : (
          <Redirect to="/Login" />
        );
      }}
    />
  );
};

export default ProtectedRoute;
